export const GOOGLE_MAPS_API_KEY = 'AIzaSyDMB2lK9k5K8OgBv86jKy9G-L4x4qUP_oQ';
export const SECRET_STORAGE_KEY = '$%*@(l!TIt7b_7Rm>b04X2"6dVdOGaR;0bR\h}^X0;%.tHd"m{'
export const agoraAppId = 'c0d00230fa7c46928e28346015525ff8';
export const agoraChannel = 'doxx-12';
export const IP_API_KEY = '7adb4705dac038';
export const analyticsID= 'G-WL8J22PSQW'